import { performPostRequest } from '@atlassian/jira-fetch';
import { logErrorAndFireAnalytics } from '@atlassian/jira-software-code-commons';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const doOnError = (error: any) => {
	logErrorAndFireAnalytics({
		packageName: 'jiraSoftwareCodePage',
		locationId: 'services.one-click-connect.connect-to-bitbucket',
		message: 'Could not connect Jira to Bitbucket Account.',
		error,
	});
};

export const connectToBitbucket = async (baseUrl: string, workspaceUuid: string) => {
	const url = `${baseUrl}/rest/dvcs-connector-internal/1.0/bitbucket/autoInstall?principalUuid=${encodeURIComponent(
		workspaceUuid,
	)}`;
	try {
		await performPostRequest(url);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		doOnError(error);
		throw error;
	}
};
